import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'startDateRange',
      type: 'datepicker',
      label: '承接资源开始日期',
      otherOptions: {
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'endDateRange',
      type: 'datepicker',
      label: '承接资源结束日期',
      otherOptions: {
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'workAccount',
      label: '工作账号',
      type: 'input',
      placeholder: '请输入工作账号'
    }
  ]
}
